// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__coNNy","productName":"Table_productName__3drKq"};